<div
    class="flex flex-col gap-4 animate-pulse @xl:grid @xl:grid-cols-6"
    data-testid="official-profile-skeleton"
    aria-busy="true"
>
    <div class="flex flex-col gap-2 @xl:col-span-3">
        <div class="flex flex-row gap-4">
            <div class="h-20 w-16 shrink-0 rounded-xl bg-gray-300"></div>
            <div class="min-w-0 flex-1 space-y-2 pt-1">
                <div class="h-5 w-56 max-w-full rounded bg-gray-300"></div>
                <div class="h-4 w-32 rounded bg-gray-200"></div>
                <div class="h-3.5 w-40 rounded bg-gray-200"></div>
            </div>
        </div>

        <div class="mt-2 space-y-3">
            <div class="flex items-center gap-4">
                <div class="h-4 w-4 rounded bg-gray-200"></div>
                <div class="h-3.5 w-36 rounded bg-gray-200"></div>
            </div>
            <div class="flex items-center gap-4">
                <div class="h-4 w-4 rounded bg-gray-200"></div>
                <div class="h-3.5 w-48 rounded bg-gray-200"></div>
            </div>
            <div class="flex items-center gap-4">
                <div class="h-4 w-4 rounded bg-gray-200"></div>
                <div class="h-3.5 w-40 rounded bg-gray-200"></div>
            </div>
            <div class="flex gap-4 pt-0.5">
                <div class="h-5 w-5 rounded bg-gray-200"></div>
                <div class="h-5 w-5 rounded bg-gray-200"></div>
                <div class="h-5 w-5 rounded bg-gray-200"></div>
            </div>
        </div>

        <div class="mt-4 h-11 w-44 max-w-full rounded-lg bg-gray-300"></div>
    </div>

    <div class="flex flex-col gap-6 @xl:col-span-2">
        <div>
            <div class="mb-2 h-5 w-20 rounded bg-gray-300"></div>
            <div class="space-y-2">
                <div class="flex items-start gap-2">
                    <div class="mt-0.5 h-4 w-4 shrink-0 rounded bg-gray-200"></div>
                    <div class="min-w-0 flex-1 space-y-1.5">
                        <div class="h-3.5 w-full rounded bg-gray-200"></div>
                        <div class="h-3.5 w-2/3 rounded bg-gray-200"></div>
                    </div>
                </div>
                <div class="flex items-center gap-2">
                    <div class="h-4 w-4 shrink-0 rounded bg-gray-200"></div>
                    <div class="h-3.5 w-32 rounded bg-gray-200"></div>
                </div>
            </div>
        </div>
        <div>
            <div class="mb-2 h-5 w-16 rounded bg-gray-300"></div>
            <div class="space-y-2">
                <div class="flex items-start gap-2">
                    <div class="mt-0.5 h-4 w-4 shrink-0 rounded bg-gray-200"></div>
                    <div class="min-w-0 flex-1 space-y-1.5">
                        <div class="h-3.5 w-full rounded bg-gray-200"></div>
                        <div class="h-3.5 w-1/2 rounded bg-gray-200"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
